export interface AccountIdentity {
  id: string;
  tenant?: {
    id: string;
    name: string;
    bin: string | null;
    logoFileGuid?: string | null;
  } | null;
}

export function accountKey(account: AccountIdentity | null): string | null {
  return account ? `${account.id}:${account.tenant?.id ?? "platform"}` : null;
}

export function storedAccountKey(): string | null {
  try {
    const value = localStorage.getItem("user");
    return value ? accountKey(JSON.parse(value)) : null;
  } catch {
    return null;
  }
}

// A page with company A's form must never send it using company B's new token.
export function accountSessionMatches(
  account: AccountIdentity | null
): boolean {
  return accountKey(account) === storedAccountKey();
}
